<template lang="pug">
div
  //- a(@click='changePassword = true', v-if='!changePassword', href='#') Change password
  v-btn(flat, small, @click='changePassword = true', v-if='!changePassword')
    v-icon(dark)
      | edit
    | Change password
  .row
    form.col.s6(v-if='changePassword', @submit='onSubmit')
      .row.input-field
        input#currentPassword.validate(
          type='password',
          v-model='currentPassword',
          required
        )
        label(for='currentPassword') Current Password

      .row.input-field
        input#newPassword.validate(
          type='password',
          v-model='newPassword',
          required
        )
        label(for='newPassword') New Password
      .row.input-field
        input#confirmPassword.validate(
          type='password',
          v-model='confirmPassword',
          required
        )
        label(for='confirmPassword', data-error='Passwords must match') Confirm Password

      p.red-text(v-if='error') {{ error }}
      .row
        .col.s12.right-align
          a.btn-flat.waves-effect.waves-light(@click='clear') Cancel
          button.btn.waves-effect.waves-light(type='submit') Submit
</template>
<script>
export default {
  data () {
    return {
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      changePassword: false,
      error: null
    }
  },
  computed: {
    passwordsMatch () {
      return this.confirmPassword === this.newPassword
    }
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .put(
            `${this.$config.API_URL}/account/change-password`,
            {
              password: this.currentPassword,
              newPassword: this.newPassword,
              passwordRepeat: this.confirmPassword
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then((result) => {
            this.$snackbar.success('Password changed successfully')
            this.clear()
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.$snackbar.error('Could not change password')
              this.error = error.response.data.errors[0].messages[0]
            }

            // this.$snackbar.show({
            //     text: "An error occurred while changing your password"
            // })
          })
      })
    },
    clear () {
      this.error = null
      this.newPassword = null
      this.currentPassword = null
      this.confirmPassword = null
      this.changePassword = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-settings-password.vue